import { makeUrl } from './url';

export default function setUtmReferrer(url: string, utmReferrer: string) {
  return makeUrl(url, { referrer_location: utmReferrer });
}
